import { ReactNode } from "react";

export interface SecondaryButtonProps {
    title: string;
    outlined?: boolean;
    transparent?: boolean;
    textSize?: 'm' | 'l';
    onClick: (e: any) => void;
    widthFit?: boolean;
    icon?: ReactNode
}

export const SecondaryButton: React.FC<SecondaryButtonProps> = (btn) => {
    return (
        <div className={`${btn.widthFit ? "lg:w-fit" : ""} w-full h-fit`}>
            <button className={`${btn.widthFit ? "lg:w-fit" : ""} w-full px-2 ext-primary_darker bg-transparent py-1.5 ring-0 text-primary py-2"} ${btn.textSize == 'l' ? 'text-lg lg:text-xl' : ''} font-medium rounded-xl hover:text-primary_darker transition duration-150 flex flex-row justify-center items-center`}
            onClick={btn.onClick}>
                {btn.icon && 
                <div className="h-[26px] w-[26px] mr-1 z-20">
                    {btn.icon}
                </div>
                }
                <div>
                    {btn.title}
                </div>
            </button>
        </div>
    )
}